import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { PackageSummaryLocalDataList } from './../../helpers/results-package-helper';
import './PackageSummaryHeaders.scss';

interface PackageSummaryHeadersProps {
  summaryList: PackageSummaryLocalDataList[];
}

const PackageSummaryHeaders: React.FC<PackageSummaryHeadersProps> = ({
  summaryList,
}) => {
  const { t } = useTranslation();
  return (
    <Row>
      {summaryList.map((item) => (
        <Col key={item.key} xs={item.colWidth as any} className='pr-0'>
          <p className='font-size-9 font-weight-semi-bold fcolor--text-label summary-header-cell'>
            {t(item.title).toUpperCase()}
          </p>
        </Col>
      ))}
    </Row>
  );
};

export default PackageSummaryHeaders;
